import { TOGGLE_SIDEBAR } from "./types";

export default {
  toggleSidebar({ commit }) {
    commit(TOGGLE_SIDEBAR);
  }
};
